import { hasRole } from "@/helpers/user";
import { Inertia } from "@inertiajs/inertia";
import { Link } from "@inertiajs/inertia-react";
import Swal from "sweetalert2";

const User = ({ auth, ...user }) => {
    const { id, name } = user;

    const handleDelete = (user) => {
        Swal.fire({
            title: 'Eliminar Usuario',
            html: `Estas seguro que quieres eliminar a ${user.name}`,
            confirmButtonColor: '#ff0000',
            confirmButtonText: 'Eliminar Usuario',
            showCancelButton:true,
        }).then(response => {
            if(response.isConfirmed){
                Inertia.delete(route('users.destroy', {user: user.id}))
            }
        })
    }

    const canShowDeleteButton = (() => {
        if (!hasRole(auth.user, 'super_admin')) {
            return false;
        }

        return true;
    })();

    const canShowEditButton = (() => {
        if (!hasRole(auth.user, 'super_admin')) {
            return false;
        }

        return true;
    })();

    return (
        <div className="bg-white p-5 rounded mb-2 flex justify-between">
            <p>{name}</p>
            <div>
                {(() => {
                    return (
                        <>
                            {canShowEditButton && (
                                <Link href={`/users/${id}/edit`} className="bg-black text-white py-2 px-5 rounded mr-1">Editar</Link>
                            )}
                            {canShowDeleteButton && (
                                <button className="bg-red-600 text-white py-2 px-5 rounded"
                                    onClick={() => {handleDelete(user)}}
                                >Eliminar</button>
                            )}
                        </>
                    )
                })()}
            </div>
        </div>
    );
};

export default User;
